import {Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy} from '@angular/core';
import { SearchService, SEARCH_TYPE_CUENTA} from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MdOptionSelectionChange } from '@angular/material';

@Component({
  selector: 'app-cuenta-autocomplete',
  templateUrl: './cuenta-autocomplete.component.html',
  styleUrls: ['./cuenta-autocomplete.component.scss']
})
export class CuentaAutocompleteComponent implements OnDestroy, AfterViewInit {

  @Input('placeholder') placeholder = 'Filtrar por cuenta';
  @Input('singleValue') singleValue = false;
  @Input('cantDelete') cantDelete = false;
  @Input('disabled') disabled = false;

  @Output() ItemsSelectedChanged = new EventEmitter<boolean>();
  @Output() ViewInitialized = new EventEmitter<{}>();

  // Cuentas
  public cuentas = [];
  public cuentasStateControl: FormControl;
  public filteredCuentas: Observable<any>;
  public selectedCuentas = [];
  destroySubject = new Subject<void>();

  constructor(private searchService: SearchService) {

    // Cuentas
    this.cuentasStateControl = new FormControl();
    this.filteredCuentas = this.cuentasStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if ( (value && value.length > 2) && (!this.singleValue || this.selectedCuentas.length == 0)){
            return this.searchService.searchAutocomplete(value, SEARCH_TYPE_CUENTA);
          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          value.forEach(emp => {
            if (emp.CuentaAcopio) {
              emp.cuentasAcopios = '';
              emp.CuentaAcopio.forEach(e => {
                if (e.CuentaAcopio !== 0) {
                  emp.cuentasAcopios += e.CuentaAcopio.toString() + ', ';
                }
              });
              if (emp.cuentasAcopios.length) {
                emp.cuentasAcopios = emp.cuentasAcopios.slice(0, -2);
              }
            }
          });
          return value;
        })
        .takeUntil(this.destroySubject);
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  ngAfterViewInit() {
    setTimeout(_ => {
      this.ViewInitialized.emit();
    });
  }

  selectedCuenta(event: MdOptionSelectionChange, value) {

    if (this.singleValue && this.selectedCuentas.length > 0){
      return;
    }

    if (event.source.selected &&
          this.selectedCuentas.filter(v => v.Id === value.Id).length === 0) {
        this.selectedCuentas.push(value);
    }

    this.ItemsSelectedChanged.emit(true);
  }

  removeCuenta(cuenta){
    this.selectedCuentas.splice(this.selectedCuentas.findIndex(v => v.Id === cuenta.Id), 1);
    this.ItemsSelectedChanged.emit(true);
  }

  displayFn(value){
    return null;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/cuenta-autocomplete/cuenta-autocomplete.component.ts